import i18n from 'i18n-js';
import {Box, Text, Image, Stack} from 'native-base';
import React from 'react';
import {t} from 'react-native-tailwindcss';
import {BBVALogo} from './svg/BBVALogo';
import {BizumLogo} from './svg/BizumLogo';
import {CaixaBankLogo} from './svg/CaixaBankLogo';
import {MoneiLogo} from './svg/MoneiLogo';

type Props = {};

export const PoweredBy: React.FC<Props> = () => {
  return (
    <Box style={t.p3}>
      <Text style={[t.textCenter, t.textGray800]}>{i18n.t('poweredBy')}</Text>
      {/*<Stack*/}
      {/*  direction="row"*/}
      {/*  justifyContent="center"*/}
      {/*  alignItems="center"*/}
      {/*  style={t.mY6}*/}
      {/*  flexWrap="wrap">*/}
      {/*  <Box style={t.p3}>*/}
      {/*    <MoneiLogo height={20} />*/}
      {/*  </Box>*/}
      {/*  <Box style={t.p3}>*/}
      {/*    <CaixaBankLogo width={120} height={25} />*/}
      {/*  </Box>*/}
      {/*  <Box style={t.p3}>*/}
      {/*    <BBVALogo height={20} />*/}
      {/*  </Box>*/}
      {/*  <Box style={t.p3}>*/}
      {/*    <BizumLogo height={25} />*/}
      {/*  </Box>*/}
      {/*  <Box style={t.p3}>*/}
      {/*    <Image*/}
      {/*      style={{width: 100, height: 25, resizeMode: 'contain'}}*/}
      {/*      source={{uri: require('../assets/kpmg-logo.png')}}*/}
      {/*      alt="KPMG"*/}
      {/*    />*/}
      {/*  </Box>*/}
      {/*  <Box style={t.p3}>*/}
      {/*    <Image*/}
      {/*      style={{width: 100, height: 25, resizeMode: 'contain'}}*/}
      {/*      source={{uri: require('../assets/roca-logo.png')}}*/}
      {/*      alt="RocaJunyent"*/}
      {/*    />*/}
      {/*  </Box>*/}
      {/*</Stack>*/}
    </Box>
  );
};
